module.exports = __webpack_public_path__ + "img/chart.83a6d95.png";